import { Component, inject } from '@angular/core';
import { DemarcheItem } from '@app/models/demarche';
import { Router } from '@angular/router';
import { DemarcheService } from '@app/services/demarche.service';
import { FamilyService } from '@app/services';
import { filter } from 'rxjs';
import { computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-demarches-list',
  templateUrl: './demarches-list.component.html',
  styleUrls: ['./demarches-list.component.scss'],
  standalone: false
})
export class DemarchesListComponent {

  isLoading: boolean;

  private familyService = inject(FamilyService);
  private demarcheService = inject(DemarcheService);
  private route = inject(Router);

  currentFamily = toSignal(this.familyService.currentFamily$.pipe(filter(f => !!f)), { initialValue: null });
  config = toSignal(this.demarcheService.getConfig(), { initialValue: null });

  // Signal calculé des démarches filtrées avec hasProgress
  demarches = computed(() => {
    const family = this.currentFamily();
    const config = this.config();

    if (!family || !config) return [];

    return config.demarches
      .filter(d => d.enabled && d.displayed)
      .map(demarche => ({
        ...demarche,
        hasProgress: this.demarcheService.hasProgress(demarche.id, family.id)
      }));
  });

  onClickDemarche(demarche: DemarcheItem) {
    this.route.navigate([`account/demarches/${demarche.id}`]);
  }
}
